import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from './NavLinks';

import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';
import usePersonOrgRoleData from '@usas/ui-web/state/personOrgRole/UsePersonOrgRoleData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

const useClubRecognitionContextView = () => {
  const navigate = useNavigate();
  const { securityState, userInfo, login } = useSecurityData();
  const { clearArrayData } = usePersonOrgRoleData();
  const { selectOrgUnitState, resetSelectOrgUnitState } = useSelectOrgUnitData();

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    navigate(NavLinks.CLUB_RECOGNITION_PROGRAM_LEVEL);
  }

  const onBackToSelectionClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    resetSelectOrgUnitState();
    clearArrayData();
    goToClubRecognitionRoot();
  }

  useEffect(() => {
    if (userInfo?.isLoggedIn !== true) {
      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [securityState])


  function goToClubRecognitionRoot() {
    navigate(NavLinks.CLUB_RECOGNITION_SELECTION);
  };

  return {
    isLoggedIn: securityState.isLoggedIn,
    isLoading: securityState.isLoading,
    onBackClicked,
    onBackToSelectionClicked,
    selectOrgUnitState
  };
};

export default useClubRecognitionContextView;
